import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './QuizPage.css';
import LoadingScreen from '../components/LoadingScreen';

function QuizPage() {
  const navigate = useNavigate();

  const [screenState, setScreenState] = useState('loading');
  const [currentQuestion, setCurrentQuestion] = useState(0);
  const [answers, setAnswers] = useState({});

  const questions = [
    {
      id: 1,
      text: 'How many trade shows do you manage annually?',
      multiSelect: false,
      options: ['1-5', '5-10', '10-20', '20+'],
    },
    {
      id: 2,
      text: 'What is your annual trade show budget?',
      multiSelect: true,
      options: ['$50,000', '$50-$100K', '$100-$250K', '$250K+'],
    },
	{
	id: 3,
      text: 'How many leads to you get each year?',
      multiSelect: false,
      options: ['put textbox here'],
    },
{
	id: 4,
      text: 'what purpose do you have for this app?',
      multiSelect: true,
      options: ['None', 'personal', 'buisiness', 'other'],
    },
    {
      id: 5,
      text: 'How soon do you want results?',
      multiSelect: false,
      options: ['Immediately', '1-3 months', '3-6 months', 'Long-term'],
    },
  ];

  useEffect(() => {
    if (screenState === 'loading') {
      const timer = setTimeout(() => {
        setScreenState('form');
      }, 2500);

      return () => clearTimeout(timer);
    }
  }, [screenState]);

  const current = questions[currentQuestion];
  const selectedAnswers = answers[current.id] || [];

  const handleOptionChange = (option) => {
    if (current.multiSelect) {
      setAnswers((prev) => {
        const currentSelections = prev[current.id] || [];
        const alreadySelected = currentSelections.includes(option);

        return {
          ...prev,
          [current.id]: alreadySelected
            ? currentSelections.filter((item) => item !== option)
            : [...currentSelections, option],
        };
      });
    } else {
      setAnswers((prev) => ({
        ...prev,
        [current.id]: [option],
      }));
    }
  };

  const handleNext = (e) => {
    e.preventDefault();

    if (selectedAnswers.length === 0) return;

    if (currentQuestion < questions.length - 1) {
      setCurrentQuestion((prev) => prev + 1);
    } else {
      navigate('/dashboard');
    }
  };

  const handleSkip = () => {
    navigate('/dashboard');
  };

  if (screenState === 'loading') {
    return <LoadingScreen />;
  }

  return (
    <div className="QuizPage-page">
      <div className="QuizPage-container">
        <div className="QuizPage-card">
          <div className="QuizPage-progress">
            {String(currentQuestion + 1).padStart(2, '0')} / {String(questions.length).padStart(2, '0')}
          </div>

          <h2 className="QuizPage-title">Before Going to Dashboard</h2>
          <p className="QuizPage-subtitle">Take Quiz</p>

          <form onSubmit={handleNext}>
            <p className="QuizPage-question">
              {current.id}. {current.text}
            </p>

            <div className="QuizPage-options">
              {current.options.map((option, index) => {
                const isChecked = selectedAnswers.includes(option);

                return (
                  <label key={index} className="QuizPage-option">
                    <input
                      type={current.multiSelect ? 'checkbox' : 'radio'}
                      name={`question-${current.id}`}
                      value={option}
                      checked={isChecked}
                      onChange={() => handleOptionChange(option)}
                    />
                    <span>{option}</span>
                  </label>
                );
              })}
            </div>

            <button
              type="submit"
              className="QuizPage-button"
              disabled={selectedAnswers.length === 0}
            >
              {currentQuestion === questions.length - 1 ? 'Submit' : 'Next >>'}
            </button>
          </form>
        </div>

        <button type="button" className="QuizPage-skip" onClick={handleSkip}>
          Skip For Now
        </button>
      </div>
    </div>
  );
}

export default QuizPage;